import { C4_BOT_ID, isCpu } from '@xox/shared'

/** The `--robot-*` override class a house bot's face wears (empty = the default violet). */
export function robotPaletteFor(botId: string | null | undefined): string {
  if (!isCpu(botId)) return ''
  return botId === C4_BOT_ID ? 'robot-c4' : ''
}

/**
 * A house bot's face. Drawn, not an emoji, so it looks the same on every phone; the eyes pulse
 * while it is "thinking". Palette tokens live in index.css (`--robot-*`), re-skinned per bot by
 * a class such as `robot-c4`.
 */
export function RobotFace({
  thinking = false,
  className = '',
  palette = '',
}: {
  thinking?: boolean
  className?: string
  palette?: string
}) {
  return (
    <svg viewBox="0 0 40 40" className={`${palette} ${className}`} aria-hidden>
      {/* antenna */}
      <path d="M20 9 V4" stroke="var(--robot-shell)" strokeWidth="2.2" strokeLinecap="round" />
      <circle cx="20" cy="3.5" r="2.2" fill="var(--robot-eye)" />
      {/* ear bolts */}
      <rect x="3" y="18" width="4" height="8" rx="1.5" fill="var(--robot-shell-dark)" />
      <rect x="33" y="18" width="4" height="8" rx="1.5" fill="var(--robot-shell-dark)" />
      {/* head */}
      <rect x="6" y="9" width="28" height="26" rx="8" fill="var(--robot-shell)" />
      <path
        d="M11 11 H29"
        stroke="var(--robot-shell-light)"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      {/* visor */}
      <rect x="9.5" y="15" width="21" height="10" rx="5" fill="var(--robot-visor)" />
      <g className={thinking ? 'animate-pulse' : ''}>
        <rect x="12.5" y="17.5" width="6" height="5" rx="2.5" fill="var(--robot-eye)" />
        <rect x="21.5" y="17.5" width="6" height="5" rx="2.5" fill="var(--robot-eye)" />
        <rect x="14" y="18.5" width="2" height="1.4" rx=".7" fill="white" opacity=".8" />
        <rect x="23" y="18.5" width="2" height="1.4" rx=".7" fill="white" opacity=".8" />
      </g>
      {/* mouth grille */}
      <path
        d="M14 29 H26 M14 31.5 H26"
        stroke="var(--robot-shell-dark)"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M17 29 V31.5 M20 29 V31.5 M23 29 V31.5"
        stroke="var(--robot-shell-dark)"
        strokeWidth="1.2"
      />
    </svg>
  )
}
